import axios from "_u/axios"

// 优惠券列表
export const cInfoList = body => {
    return axios.post("api/coupon/info/list", body)
}

// 优惠券查看
export const cInfoView = id => {
    return axios.post("api/coupon/info/view", { id })
}

// 优惠券新增
export const cInfoAdd = body => {
    return axios.post("api/coupon/info/add", body)
}

// 优惠券更新
export const cInfoUpdate = body => {
    return axios.post("api/coupon/info/update", body)
}

// 优惠券状态更改
export const cInfoEnable = id => {
    return axios.post("api/coupon/info/enable", { id })
}

// 优惠券明细列表
export const cInfoDetailList = body => {
    return axios.post("api/coupon/info/useViewList", body)
}







// 广告管理列表
export const nInfoList = body => {
    return axios.post("api/notify/info/list", body)
}

// 广告管理新增
export const nInfoAdd = body => {
    return axios.post("api/notify/info/add", body)
}

// 广告管理删除
export const nInfoDelete = id => {
    return axios.post("api/notify/info/delete", { id })
}

// 广告管理更新
export const nInfoUpdate = body => {
    return axios.post("api/notify/info/update", body)
}

// 广告管理查看
export const nInfoView = id => {
    return axios.post("api/notify/info/view", { id })
}

// 广告状态更改
export const nInfoRelease = id => {
    return axios.post("api/notify/info/release", { id })
}